import type { NavigationItem } from '@/shared/types/navigation'

// Navigation items use i18n keys for labels
// Components should translate using $t() or t()
export const FLOWS_DEMO_ROUTE = '/chains/demo'

export const primaryNavigation: NavigationItem[] = [
  { name: 'dashboard', label: 'nav.dashboard', route: '/dashboard' },
  { name: 'chains', label: 'nav.chains', route: FLOWS_DEMO_ROUTE, matchRoutes: ['/chains'] },
  { name: 'affiliate', label: 'nav.affiliate', route: '/affiliate' },
  { name: 'wallet', label: 'nav.wallet', route: '/wallet' },
  { name: 'profile', label: 'nav.profile', route: '/profile' },
]

export const secondaryNavigation: Record<string, NavigationItem[]> = {
  affiliate: [
    { name: 'info', label: 'nav.invitation', route: '/affiliate/partner' },
    { name: 'teams', label: 'nav.referrals', route: '/affiliate/teams' },
    { name: 'curator', label: 'nav.myCurator', route: '/affiliate/curator' },
  ],
  wallet: [
    { name: 'overview', label: 'nav.wallet', route: '/wallet' },
    { name: 'history', label: 'nav.history', route: '/wallet/history' },
  ],
}
